module.exports = __webpack_public_path__ + "img/logo.a4366d08.png";